import axios from 'axios'
import { clearToken } from './auth.js'
import { getToken } from '@/services/auth.js'
import config from '@/config.js'

// Get API URL from environment variable or use default
// Safe environment accessor that works with Vite (import.meta.env),
// webpack (process.env) or a global `window.__ENV` object.


const API_URL = config?.url?.api

// Create axios instance with base configuration
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  timeout: 10000 // 10 second timeout
})

// Request interceptor
api.interceptors.request.use(
  config => {
    // Log request for debugging
    console.log(`API Request: ${config.method.toUpperCase()} ${config.baseURL}${config.url}`)
    
    // Add auth token if available (respects storage settings)
    const token = getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

// Response interceptor
api.interceptors.response.use(
  response => {
    console.log(`API Response: ${response.status} ${response.config.method.toUpperCase()} ${response.config.url}`)
    
    // Debug: Log raw response data for product endpoints
    if (response.config.url.includes('/products/')) {
      console.log('Raw response data:', response.data)
      if (response.data.data?.gallery) {
        console.log('Gallery type:', typeof response.data.data.gallery)
        console.log('Gallery value:', response.data.data.gallery)
      }
    }
    
    return response
  },
  error => {
    console.error('API Error:', error.message)
    if (error.response) {
      console.error('Status:', error.response.status)
      console.error('Data:', error.response.data)
    }
    
    if (error.response?.status === 401) {
      // Handle unauthorized access
      clearToken()
      // Redirect to login page
      try {
        window.location.href = '/login'
      } catch (e) {
        // ignore in non-browser environments
      }
    }
    return Promise.reject(error)
  }
)

export default api